import React, { useEffect, useState, useRef } from 'react';
import { prefetchGoogleClientId } from '../../utils/googleClientId';
import { colors } from '../../styles/globalStyles';

export const GoogleLoginButton = ({ onSuccess }) => {
  const [googleLoaded, setGoogleLoaded] = useState(false);
  const [error, setError] = useState(null);
  const [clientId, setClientId] = useState(null);
  const onSuccessRef = useRef(onSuccess);
  const initializedRef = useRef(false);

  useEffect(() => { onSuccessRef.current = onSuccess; }, [onSuccess]);

  useEffect(() => {
    prefetchGoogleClientId().then(id => setClientId(id));
  }, []);

  useEffect(() => {
    if (clientId === null) return;

    if (!clientId) {
      setError('Google Client ID não configurado. Configure em Integrações → Google OAuth.');
      return;
    }

    if (initializedRef.current) return;

    const initGoogleAuth = () => {
      if (!window.google?.accounts?.id) return;
      try {
        window.google.accounts.id.initialize({
          client_id: clientId,
          callback: (response) => {
            if (onSuccessRef.current) onSuccessRef.current(response.credential);
          },
          auto_select: true,
          itp_support: true,
        });

        window.google.accounts.id.renderButton(
          document.getElementById('googleSignInDiv'),
          {
            theme: 'filled_blue',
            size: 'large',
            width: 360,
            text: 'signin_with',
            type: 'standard',
            shape: 'rectangular'
          }
        );

        window.google.accounts.id.prompt();
        initializedRef.current = true;
        setGoogleLoaded(true);
        setError(null);
      } catch (err) {
        console.error('Erro na inicialização Google Sign-In:', err);
        setError('Erro na configuração do Google Sign-In');
      }
    };

    if (!window.google) {
      const script = document.createElement('script');
      script.src = 'https://accounts.google.com/gsi/client';
      script.async = true;
      script.defer = true;
      script.onload = () => setTimeout(initGoogleAuth, 100);
      script.onerror = () => setError('Falha ao carregar Google Sign-In.');
      document.head.appendChild(script);
    } else {
      initGoogleAuth();
    }

    return () => {
      if (window.google?.accounts?.id) {
        window.google.accounts.id.cancel();
      }
    };
  }, [clientId]);

  if (error) {
    return (
      <div style={{
        backgroundColor: '#fee2e2',
        color: '#991b1b',
        padding: '1rem',
        borderRadius: '0.5rem',
        textAlign: 'center'
      }}>
        {error}
      </div>
    );
  }

  return (
    <div style={{ position: 'relative', minHeight: '44px' }}>
      {!googleLoaded && (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '0.5rem',
          color: colors.gray
        }}>
          <div style={{
            width: '16px',
            height: '16px',
            border: '2px solid #e2e8f0',
            borderTopColor: colors.primary,
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }}></div>
          Carregando...
        </div>
      )}
      <div
        id="googleSignInDiv"
        style={{
          opacity: googleLoaded ? 1 : 0,
          transition: 'opacity 0.3s ease'
        }}
      />
    </div>
  );
};
